var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconresilience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1491_604",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1491_604",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAACSklEQVR4nO1bMU/CQBTuv/DqZHyGH6CLbrhpXBxMTJz9A5gYR4HJRXenw0GT9g+ww+zi4l6kG4TEhbYmNUVRUpH26LvLXXlf8gaS473vfX3vhvJhWQQCgUAgKEfE145Czt5CznpRix1aq4aQs17YsuOvYJ5VBkQtdjhpjLPemNvHi87+Nv8Vi84muaZ5tZ6WcOapBtyOgof106ICJDmSXD9nOetZZoy1vVCEPAL8aV73dRlz+zhNOPk8bx2yBBDJpRWCeU9tzthmXYIi02SACMz798JsMS/i7KDIfaIlxtObO2lwiZt7ViDtx750AKdfP3uNY5HYb3RvSsEPnH4dXD8WLtDsKhFBKj/4Tr50AckiSOUHrn8xTV6owCQ6NfTmZfMD1x9iFag2OwMJAsjlBzPJiyvcjSUIIJcfpAqcvHzkTp6cVS0AOj9IFdhpD3IVSc5stwfKBUDnB6kCoqFaAHR+QAL4NAFAK+Cj7djoHCaRfvGxbBh3B4xIAJiIENyvr/YEvF9uoIhgrAAjpCABXJqAmFbANegOsJBh3ApYpgtQefRyJ688ecoFQOcHqS/t3j3nKpIk37t9Vi4AOj/IGBnRkC0AOj8gAfyVn4Ah1oipeC2Ozm/L8Wt4O4b/w4gSfptO/6pogWqzc43dvFJ+m99FdGteKT9w+nXhAo1uXXbzpvAjYJgbRUyX2iHIYW7M8goba5IKcpobS2mTG6+6UTJUYZU1xSscyDJL6+wVjgTMjXkFwDBdaomwjH+YEEGWV5hAIBAIBEs6PgFlPqfiZVAHqgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconresilience);
export default __webpack_public_path__ + "static/media/icon.resilience.a354b8d490c762a852ab55f6e39362e3.svg";
export { ForwardRef as ReactComponent };